import { parse } from 'query-string'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, withState } from 'recompose'
import { push } from 'react-router-redux'
import { loadReCaptcha } from 'react-recaptcha-google'
import { track } from 'utils/trackingUtils'

import * as UserSelectors from 'modules/user/selectors'
import * as UserActions from 'modules/user/actions'
import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as ExperimentSelectors from 'modules/experiment/selectors'
import * as RoutingSelectors from 'modules/routing/selectors'
import { page } from 'utils/trackingUtils'
import { Flow } from 'constants/flowConstants'
import { isEmailValid } from 'utils/email'

import SignupCard from './component'

const mapStateToProps = state => ({
  password: UserSelectors.getPassword(state),
  email: UserSelectors.getEmail(state) || '',
  createOrgError: OrgSelectors.getCreateOrgError(state),
  validEmail: UserSelectors.getValidEmail(state),
  splitLoading: ExperimentSelectors.getLoading(state),
  checkEmailIsSSOEnabledPending: UserSelectors.checkEmailIsSSOEnabledPending(state),
  createOrgLoading: OrgSelectors.getCreateOrgLoading(state),
  search: RoutingSelectors.getSearch(state),
  pathname: RoutingSelectors.getPathname(state),
  disabledEmail: UserSelectors.getDisabledEmail(state),
  domainFound: UserSelectors.hasAssociatedDomain(state),
  existingFlow: UserSelectors.getFlow(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setPassword: UserActions.setPassword,
    setValidEmail: UserActions.setValidEmail,
    setEmail: UserActions.setEmail,
    fetchClearbitForEmail: UserActions.fetchClearbitForEmail,
    setFlow: UserActions.setFlow,
    checkEmailIsSSOEnabled: UserActions.checkEmailIsSSOEnabled,
    exchangeGoogleCodeForDriftCode: OrgActions.exchangeGoogleCodeForDriftCode,
    findAssociatedDomain: UserActions.findAssociatedDomain,
    push,
  }, dispatch),
})

export default compose(
  withState('hideError', 'setHideError', false),
  withState('recaptchaReference', 'setRecaptchaReference', ''),
  withState('verifyCallback', 'setVerifyCallback', ''),
  withState('hideRecaptcha', 'setHideRecaptcha', true),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (document.referrer.includes('powered-by')) {
        this.props.setHideRecaptcha(false)
        loadReCaptcha();
      }
      if (this.props.email) {
        this.props.actions.findAssociatedDomain()
      }
      const { flow } = parse(window.location.search)
      this.props.actions.setFlow(flow || Flow.WIDGET)
      page('Onboarding Account Setup', {
        context: 'widget-onboarding',
      })
    },
  }),
  withHandlers({
    onEmailChange: props => event => {
      props.actions.setEmail(event.target.value)
      props.setHideError(true)
      props.actions.setValidEmail(true)
      props.onValueChange && props.onValueChange()
      props.actions.findAssociatedDomain()
    },
    onPasswordChange: props => event => {
      props.actions.setPassword(event.target.value)
      props.onValueChange && props.onValueChange()
    },
    onProcessingGoogleCode: props => event => {
      if (event.code) {
        props.actions.exchangeGoogleCodeForDriftCode(event.code)
      }
    },
    onFindMyTeamClick: props => () => {
      track('Onboarding Find My Team Accepted', {
        context: 'verify email step'
      })
      props.actions.push('/start/findTeam/verify')
    },
    onContinueClick: props => () => {
      if (isEmailValid(props.email)) {
        props.actions.fetchClearbitForEmail(props.email)
        props.actions.checkEmailIsSSOEnabled()
        props.setHideError(!!props.createOrgError)
      } else {
        props.setHideError(false)
        props.actions.setValidEmail(false)
      }
     }
    },
  )
)(SignupCard)



// WEBPACK FOOTER //
// ./src/layouts/SignupCard/index.js